import React, { Fragment, useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import { Link, useLocation,useNavigate } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import Select from "react-select";
import { toastError, toastSuccess } from "../../../common/Toast";

const Permission = (props, { title, content, index }) => {
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const locationID = localStorage.getItem("Location");
  const [loading, setLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(0);
  const [rolesDropdown, setRolesDropdown] = useState([]);
  const [usersDropdown, setUsersDropdown] = useState([]);
  const [userSelect, setUserSelect] = useState([]);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [moduleListing, setModuleListing] = useState([]);
  const [accordionContent, setAccordionContent] = useState([]);
  const [showcardblock, setShowCardBlock] = useState([{ name: null }]);
  const [formValues, setFormValues] = useState({
    UserId: "",
    PermissionIds: "",
    LocationIds: "",
    LoginUserId: "",
  });
  const [checked, setChecked] = useState([]);
  const [userError, setUserError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [accordionShowHide, setAccordionShowHide] = useState([]);
  const [permissionTemplate, setPermissionTemplate] = useState([]);

  // Dropdown
  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "10px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  console.log(selectedOptions,"selectedOptions")

  const toggleAccordion = (name, index) => {
    if (accordionShowHide.includes(index)) {
      setAccordionShowHide((current) =>
        current.filter((fruit) => fruit !== index)
      );
    } else {
      setAccordionShowHide([...accordionShowHide, index]);
    }
    console.log("accordionShowHide ==>", accordionShowHide);
  };



  const handleAccordionHeaderCheckbox = (e, parentIndex) => {
    const isChecked = e.target.checked;
    const module = moduleListing[parentIndex];
    const childPermissions = accordionContent.filter(
      (data) => data.ModuleName === module.ModuleName
    );
    const childIds = childPermissions.map((data) => data.Id);
    console.log("childIds", childIds);

    setUserSelect((prevUserSelect) => {
      const prevSelectedPermissions = prevUserSelect.filter(
        (userdata) => !childIds.includes(userdata.PermissionId)
      );

      const newPermissions = isChecked
        ? childIds.map((id) => ({
            PermissionId: id,
          }))
        : [];

      const updatedUserSelect = [...prevSelectedPermissions, ...newPermissions];
      console.log("updatedUserSelect", updatedUserSelect);
      return updatedUserSelect;
    });
  };
  let navigate = useNavigate();
  const handleDropdownData = () => {
    // setLoading(true);
    axios
      .get(`${config.employeesBaseUrl}/employees/rolesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("rolesdropdown", res);
        setRolesDropdown(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    axios
      .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("usersdropdown", res);
        setUsersDropdown(res.data.ResponseData);
        setLoading(false);

        return res;
      });
    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("locationdropdown", res);
        setLocationDropdown(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

      axios
      .get(`${config.employeesBaseUrl}/employees/permissiontemplatedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("usersdropdown", res);
        setPermissionTemplate(res.data.ResponseData);
        setLoading(false);
        return res;
      });
  };

  console.log(selectedTemplate,"selectedTemplatelength")

  const userHandleDropdown = (event) => {
    console.log("userdropdown", event);
    // console.log("userdropdown", event.value);
    setSelectedOptions(event ? event : []);
    if(event.length === 1 && selectedTemplate == 0){
    setLoading(true);
    axios
      .get(
        `${config.employeesBaseUrl}/employees/userfindbyid?id=${
          // event ? event.value : 0
          event[0]?.value
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log(
          "response.data.ResponseData : ==>",
          response.data.ResponseData
        );
        var resData = response.data.ResponseData;
        setUserSelect(resData);
        // For saving data at the time of userDropdown binding
        resData.forEach((object) => {
          if (object.PermissionId > 0) {
            setChecked((prevChecked) => [...prevChecked, object.PermissionId]);
          }
        });
        setLoading(false);

        console.log("Checked Log", checked);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
    setUserError(false);
    }
    else {
      if (selectedTemplate == 0){
      setUserSelect([]);   
      setChecked([]);
    }
  }
  };

  const handlelisting = () => {
    axios
      .get(`${config.employeesBaseUrl}/employees/permissionselectall`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const ModulesName = res.data.ResponseData.ModulesName;
        console.log("ModulesName:", ModulesName);
        const AllData = res.data.ResponseData.AllData;
        console.log("AllData:", AllData);

        setModuleListing(ModulesName);
        //console.log("Condition", AllData.ModuleName === ModulesName.ModuleName);
        setAccordionContent(AllData);

        // Set accordionShowHide to an array containing the indices of all the accordions
        const allAccordionIndices = Array.from(
          { length: ModulesName.length },
          (_, i) => i
        );
        setAccordionShowHide(allAccordionIndices);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleCheck = (event) => {
    var updatedList = [...checked];
    console.log(event.target.value);
    if (event.target.checked) {
      updatedList = [...checked, event.target.value];
    } else {
      updatedList.splice(checked.indexOf(event.target.value), 1);
    }
    setChecked(updatedList);
    console.log(checked);
  };

  const handleAllCheckBox = (e) => {
    console.log(e.target.checked, "handleAllCheckBox");
    const checked = e.target.checked;
    if (checked) {
      setUserSelect(accordionContent.map((el) => ({ PermissionId: el.Id })));
    } else {
      setUserSelect([]);
    }
  };

  const handleSubmit = (event) => {
    if (!selectedOptions) {
      setUserError(true);
      setErrorMessage("Please select a user.");
      toastError("Please select a user.");
      return;
    }

    setLoading(true);
    const selectedPermissionIds = userSelect
      .filter((userdata) => userdata.PermissionId)
      .map((userdata) => userdata.PermissionId);

    const selectedUserIds = selectedOptions.map(option => option.value);

    // Create the form data object
    const formValuesDataToSend = {
      permissionids: selectedPermissionIds.toString(),
      userid: selectedUserIds.toString(),
      // locationid: formValues.LocationIds,
      locationid: locationID,
      loginuserid: Id,
      templateid: selectedTemplate,
    };

    //   Send the form data using axios
    axios
      .post(
        `${config.employeesBaseUrl}/employees/permissionupsert`,
        formValuesDataToSend,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess("Permission Successfully Saved");
        setLoading(false);
        navigate("/employees");
        // window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleDropdownData();
    handlelisting();
    const indexes = accordionContent.map((_, i) => i);
    setAccordionShowHide(indexes);
  }, []);

  let rolesDropdownOption = [];
  const RolesDropdown = rolesDropdown.map((u, i) => {
    rolesDropdownOption[i] = { label: u.Role, value: u.Id };
  });
  let usersDropdownOption = [];
  const userDropdown = usersDropdown.map((u, i) => {
    usersDropdownOption[i] = { label: u.Name, value: u.Id };
  });
  let locationDropdownOption = [];
  const locationDropdown = locationdropdown.map((u, i) => {
    locationDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  let templateDropdownOption = permissionTemplate.map((u) => ({
    label: u.TemplateName,
    value: u.TemplateId,
    permissionId: u.PermissionId
  }));

  const templateHandleDropdown = (event) => {

    if(event !== null){
    setChecked([]);
    setUserSelect([]);

    console.log(event, "eventgg");
    setSelectedTemplate(event.value);
    
    const templatePermissionId = event.permissionId.split(",").map(id => parseInt(id, 10)); // Convert to array of numbers
    //setUserSelect(templatePermissionId);   
    setChecked(templatePermissionId);
    const newArray = accordionContent.map((item, index) => ({
      Id: item.Id,
      UserId: 0,
      PermissionId: item.Id,
      IsActive: 1
    }));
     
    const filteredArray = newArray.filter(obj => templatePermissionId.includes(obj.Id)); // Filtering with numeric comparison
    setUserSelect(filteredArray);
  }
  else {
    if(selectedOptions.length === 1){
      setLoading(true);
      axios
        .get(
          `${config.employeesBaseUrl}/employees/userfindbyid?id=${
            // event ? event.value : 0
            // event[0]?.value
            selectedOptions[0].value
          }`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          console.log(
            "response.data.ResponseData : ==>",
            response.data.ResponseData
          );
          var resData = response.data.ResponseData;
          setUserSelect(resData);
          // For saving data at the time of userDropdown binding
          resData.forEach((object) => {
            if (object.PermissionId > 0) {
              setChecked((prevChecked) => [...prevChecked, object.PermissionId]);
            }
          });
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
      setUserError(false);
      }
      else {
        // if (selectedTemplate == 0){
        setUserSelect([]);   
        setChecked([]);
        
    }
    setSelectedTemplate(0);
  }
};
  
  console.log(selectedTemplate,"selectedTemplate");

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* page titles */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h3 className="page-title">Permission Template</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/employees"> Employees List</Link>
                </li>
                <li className="breadcrumb-item">Permission Templates</li>
              </ul>
              {/* </div> */}
            </div>
          </div>

          {/* dropdowns  */}
          <div className="row mt-2 mb-3">
            {/* <div className="col-md-4 col-sm-12 mb-2">
              <Select
                options={rolesDropdownOption}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                placeholder="Select Roles"
              // value={selectedOptions}
              />
            </div> */}
            {/* <div className="col-md-4 col-sm-12 mb-2">
              <Select
                value={
                  usersDropdownOption.find(
                    (option) => option.value === selectedOptions
                  ) || ""
                }
                onChange={(event) => userHandleDropdown(event)}
                options={usersDropdownOption}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                placeholder="Select Users"
                id="userDropdown"
                name="userDropdown"
              />
              {userError && <div style={{ color: "red" }}>{errorMessage}</div>}
            </div> */}
                          <div className="col-md-4 col-sm-12 mb-2">
                            <Select
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              // hideSelectedOptions={true}
                              isClearable={true}
                              isMulti={true}
                              onChange={(event) => userHandleDropdown(event)}
                              options={usersDropdownOption}
                              placeholder="Select User(s)"
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              id="userDropdown"
                              name="userDropdown"
                              // className="w-75  custom-search-select"
                              // value={
                              //   usersDropdownOption.find(
                              //     (option) => option.value === selectedOptions
                              //   ) || ""
                              // }
                              value={selectedOptions}
                            />
                            {userError && <div style={{ color: "red" }}>{errorMessage}</div>}
                           </div>

                           <div className="col-md-4 col-sm-12 mb-2">
                          
                          <Select
                            // backspaceRemovesValue={false}
                            // controlShouldRenderValue={true}
                            isClearable={true}
                            options={templateDropdownOption}
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                            onChange={(event) => templateHandleDropdown(event)}
                            placeholder="Select Permission Template"
                            value={templateDropdownOption.find((e) => e.value === selectedTemplate)}
                          />
                        </div>
            
            {/* <div className="col-md-4 col-sm-12 mb-2">
              <Select
                options={locationDropdownOption}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                isMulti={true}
                placeholder="Select Locations"
              // value={selectedOptions}
              />
            </div> */}

            {/* <div className="float-buttons-container col-sm-8">
              <div className="mt-4 mb-5 float-buttons">
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Save
                </button>
                <Link to="/employees">
                  <button className="btn btn-dark me-2">Cancel</button>
                </Link>
              </div>
            </div> */}
            <div className="float-buttons">
              <button className="btn btn-primary" onClick={handleSubmit}>
                Save
              </button>
              <Link to="/employees">
                <button className="btn btn-dark">Cancel</button>
              </Link>
            </div>
          </div>
          <div className="card mb-3">
              <div className="card-header p-3">

              <div className="form-check d-flex gap-2 align-items-center w-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={userSelect?.length === accordionContent.length}
                  onChange={(e) => handleAllCheckBox(e)}
                  />
                <label className="form-check-label font-bold">
                  Check All Permission
                </label>
                  </div>
              </div>
            </div>

          <Fragment>
            <Loader loading={loading} />
            {moduleListing.map((option, index) => {
              const childPermissions = accordionContent.filter(
                (data) => data.ModuleName === option.ModuleName
              );

              return (
                <div key={index}>
                  <div className="card mb-3">
                    <div className="card-header p-3">
                      <p className="card-title">
                        <CLink
                          className="accordion-title"
                          id={`heading${index}`}
                          onClick={() =>
                            toggleAccordion(option.ModuleName, index)
                          }
                        >
                          <div className="form-check d-flex gap-2 align-items-center w-2">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={
                                userSelect.filter((userdata) =>
                                  childPermissions.some(
                                    (data) => data.Id === userdata.PermissionId
                                  )
                                ).length === childPermissions.length
                              }
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) =>
                                handleAccordionHeaderCheckbox(
                                  e,
                                  index,
                                  childPermissions
                                )
                              }
                            />
                            <label className="form-check-label">
                              {option.ModuleName}
                            </label>
                            <i
                              className={`fas ${
                                accordionShowHide.includes(index) === true
                                  ? "fa-chevron-up"
                                  : "fa-chevron-down"
                              }`}
                            ></i>
                          </div>
                        </CLink>
                      </p>
                    </div>
                    <div
                      className={
                        accordionShowHide.includes(index) === true
                          ? ""
                          : "d-none"
                      }
                    >
                      <div className="card-body">
                        <form>
                          <div className="row">
                            {/* Dynamic Binding */}
                            {accordionContent
                              .filter(
                                (data) => data.ModuleName === option.ModuleName
                              )
                              .map((data, index) => (
                                <React.Fragment key={index}>
                                  <div className="col-md-4 col-sm-6 mb-0">
                                    <span>
                                      {userSelect
                                        .filter((userdata) => {
                                          return (
                                            userdata.PermissionId === data.Id
                                          );
                                        })
                                        .map((u, i) => u.id)}
                                    </span>
                                    <div className="form-check d-flex">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={`permission_${index}`}
                                        name={`permission_${index}`}
                                        value={data.Id}
                                        // style={{
                                        //   width: "1.1em",
                                        //   height: "1.1em",
                                        // }}
                                        checked={
                                          userSelect.filter(
                                            (userdata) =>
                                              userdata.PermissionId === data.Id
                                          ).length > 0
                                            ? true
                                            : false
                                        }
                                        onInput={handleCheck}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            // Add the selected permission to userSelect
                                            setUserSelect([
                                              ...userSelect,
                                              { PermissionId: data.Id },
                                            ]);
                                          } else {
                                            // Remove the selected permission from userSelect
                                            setUserSelect(
                                              userSelect.filter(
                                                (userdata) =>
                                                  userdata.PermissionId !==
                                                  data.Id
                                              )
                                            );
                                          }
                                        }}
                                      />

                                      <label
                                        className="form-check-label ms-2"
                                        // htmlFor={`permission_${index}`}
                                      >
                                        {data.PermissionName}
                                      </label>
                                    </div>
                                  </div>
                                </React.Fragment>
                              ))}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Fragment>
          {/* <div className="float-buttons-container">
            <div className="mt-4 mb-5 float-buttons">
              <button className="btn btn-primary" onClick={handleSubmit}>
                Save
              </button>
              <Link to="/employees">
                <button className="btn btn-dark me-2">Cancel</button>
              </Link>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Permission;
